<template>
  <div>

    <CCard class="bg-style2 mb-4">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span  class="font-weight-bold h6">  {{ caption }} </span>
        <span class="font-weight-bold float-right"> Total : {{this.extractByKeys(this.replaceByWithAccountId(JSON.parse(JSON.stringify(this.org)))).length}}</span>
      </CCardHeader>
      <CCardBody>

        <org-chart
            class="mb-2"
            :pan="true"
            :datasource="org"
            @node-click="selectNode"
            @node-clicks="selectNodeE"
        ></org-chart>

        <CRow>
          <CCol col="12" class="text-right">

<!--            <CButton class="mr-3 " v-c-tooltip.hover.click="'SEND'" size="sm" color="success" shape="pill" variant="outline" @click="onGeneral"  >-->
<!--              <CIcon name="cil-sitemap"/> <samp class="ml-1 mr-1">General</samp>-->
<!--            </CButton>-->

            <CButton  v-c-tooltip.hover.click="'Save'" size="sm" color="info" shape="pill" variant="outline" @click="onSave"  >
              <CIcon name="cil-save"/> <samp class="ml-1 mr-1">SAVE</samp>
            </CButton>
          </CCol>
        </CRow>

      </CCardBody>
    </CCard>


  </div>
</template>

<script>
import OrgChart from "./components/OrganizationChartContainer.vue";
import SearchProfile from "@/projects/components/Dialog/SearchProfile";

export default {
  name: "organization",
  components: {
    SearchProfile,
    OrgChart,
  },
  props:{
    caption: {
      type: String,
      default: ''
    },
    org: {
      type: Object,
      default: {
        id: null,
        type: null,
        name: null,
        children: []
      }
    }
  },
  data() {
    return {
      isShow:false,
      nodeData:null,
    };
  },
  methods: {
    selectNodeE(nodeData) {
      console.log(2,"index",nodeData)
    },
    selectNode(nodeData) {
      this.$emit("node-click", nodeData);

      // this.nodeData = nodeData;
      // this.isShow = true;

    },
    onAddMember(){
      this.isShow = false;
    },

    // save
    onSave(){
      const data = JSON.parse(JSON.stringify(this.org));
      // this.$store.dispatch("affiliationChart/update",this.replaceByWithAccountId(data))
      this.$store.dispatch("agencyChart/update",this.replaceByWithAccountId(data))
    },
    replaceByWithAccountId(data) {

      // ถ้า data มีฟิลด์ by
      if (data.by && data.by && data.by._id) {
        // แทนที่ by ด้วยค่า accounts._id
        data.by = data.by._id;
      }

      // ถ้า data มี children ให้ทำการวนซ้ำและเรียกฟังก์ชันนี้ซ้ำ
      if (Array.isArray(data.children)) {
        data.children.forEach(child => this.replaceByWithAccountId(child));
      }
      return data;
    },

    //end save

    onGeneral(){
      const data = JSON.parse(JSON.stringify(this.org));
      // console.log(this.replaceByWithAccountId(data))
      //
      // console.log(this.extractByKeys(this.replaceByWithAccountId(data)))

    },
    extractByKeys(jsonData,key) {
      let result = [];
      // ฟังก์ชันค้นหาแบบ recursion
      function recursiveSearch(data) {
        // ตรวจสอบว่าข้อมูลเป็น object หรือ array
        if (typeof data === 'object' && data !== null) {
          // ถ้ามี key 'by' ให้เพิ่มค่าเข้าไปในผลลัพธ์
          if (data.hasOwnProperty('by')) {
            result.push(data.by);
          }

          // วนลูปผ่านค่าทั้งหมดภายใน object หรือ array
          for (let key in data) {
            if (data.hasOwnProperty(key)) {
              recursiveSearch(data[key]);
            }
          }
        }
      }

      // เริ่มค้นหาจากข้อมูล JSON
      recursiveSearch(jsonData);
      return result;
    }
  },
};
</script>
